export var ProcessingQueueItemStatus;
(function (ProcessingQueueItemStatus) {
    ProcessingQueueItemStatus["PENDING"] = "pending";
    ProcessingQueueItemStatus["PROCESSING"] = "processing";
    /**
     * Result of the python-side OCR processing. QA is required.
     * Once migrating to a nearly fully autonomous order creation system as a result of PDF input,
     * this status will be maintained to communicate partial success, low confidence, or failed processing.
     */
    ProcessingQueueItemStatus["PROCESSED"] = "processed";
    /** Document failed to process via OCR. */
    ProcessingQueueItemStatus["FAILED"] = "failed";
    /** Result of QA'd processed queue item. At this point, it is assigned an orderID and bookingID. */
    ProcessingQueueItemStatus["CONFIRMED"] = "confirmed";
})(ProcessingQueueItemStatus || (ProcessingQueueItemStatus = {}));
export var TextExtractionClassification;
(function (TextExtractionClassification) {
    TextExtractionClassification["STRING"] = "string";
    TextExtractionClassification["ID"] = "id";
    /** User information classifications */
    TextExtractionClassification["PRIMARY_INSURANCE_CARRIER"] = "primaryInsuranceCarrier";
    TextExtractionClassification["PRIMARY_POLICY_NUMBER"] = "primaryPolicyNumber";
    TextExtractionClassification["PRIMARY_POLICY_HOLDER"] = "primaryPolicyHolder";
    TextExtractionClassification["SECONDARY_INSURANCE_CARRIER"] = "secondaryInsuranceCarrier";
    TextExtractionClassification["SECONDARY_POLICY_NUMBER"] = "secondaryPolicyNumber";
    TextExtractionClassification["SECONDARY_POLICY_HOLDER"] = "secondaryPolicyHolder";
    TextExtractionClassification["FIRST_NAME"] = "firstName";
    TextExtractionClassification["LAST_NAME"] = "lastName";
    TextExtractionClassification["MIDDLE_NAME"] = "middleName";
    TextExtractionClassification["DOB"] = "dob";
    TextExtractionClassification["SEX"] = "sex";
    TextExtractionClassification["PHONE"] = "phone";
    TextExtractionClassification["EMAIL"] = "email";
    TextExtractionClassification["ADDRESS"] = "address";
    /** Order related classifications */
    TextExtractionClassification["COLLECT_BY"] = "collectBy";
    TextExtractionClassification["COLLECT_AFTER"] = "collectAfter";
    TextExtractionClassification["COLLECT_BEFORE"] = "collectBefore";
    TextExtractionClassification["COLLECT_ON"] = "collectOn";
    TextExtractionClassification["COLLECT_IN_RANGE"] = "collectInRange";
    TextExtractionClassification["FASTING_REQUIRED"] = "fastingRequired";
})(TextExtractionClassification || (TextExtractionClassification = {}));
export var TextExtractionResultGroupType;
(function (TextExtractionResultGroupType) {
    TextExtractionResultGroupType["ICD10"] = "icd10";
    TextExtractionResultGroupType["INITIATING_OFFICE"] = "initiatingOffice";
    TextExtractionResultGroupType["INSURANCE"] = "insurance";
    TextExtractionResultGroupType["LAB_ACCOUNT"] = "labAccount";
    TextExtractionResultGroupType["OFFICE"] = "office";
    TextExtractionResultGroupType["ORDER"] = "order";
    TextExtractionResultGroupType["PATIENT"] = "patient";
    TextExtractionResultGroupType["PRESCRIBER"] = "prescriber";
    TextExtractionResultGroupType["PRODUCTS"] = "products";
    TextExtractionResultGroupType["SCHEDULING_USER"] = "schedulingUser";
    TextExtractionResultGroupType["STATIC_TEXT"] = "staticText";
    TextExtractionResultGroupType["UNKNOWN"] = "unknown";
})(TextExtractionResultGroupType || (TextExtractionResultGroupType = {}));
//# sourceMappingURL=processingQueue.js.map